<template>
	<div>
		<div class="container">
			<success-component :show="success"> <strong>Obrigado</strong>, seu cadastro foi realizado com sucesso! </success-component>
			<div class="row d-flex justify-content-center mt-10 mb-10">
				<div class="col-lg-9">
					<card-component :title="$t('messages.form.title')" :loading="loading">
						<b-card-text>
							<h1>Bem-vindo <span>à PagBrasil</span></h1>
							<p>
								Enviamos um código para <strong>{{ email }}</strong
								>. Copie e cole-o abaixo:
							</p>
						</b-card-text>
						<div class="d-flex justify-content-center">
							<code-input :fields="4" v-on:change="changeCode" v-on:complete="setCode" :value="customCode" :autoFocus="true"></code-input>
						</div>
						<div class="d-flex justify-content-center flex-column align-items-center">
							<b-button
								@click="confirmCode"
								class="mt-5 mb-3 button-access"
								:class="!buttonDisabled && !success ? 'bg-primary text-white' : ''"
								:disabled="buttonDisabled || success"
								>ACESSAR</b-button
							>
							<small class="text-danger" v-if="error">Código inválido, por favor, verifique seu e-mail e tente novamente.</small>
						</div>
						<div class="d-flex justify-content-center align-items-center flex-column">
							<small class="mt-2 mb-2" v-if="!resended">Não recebi o e-mail. <a href="#" @click="resendAccessToken">Reenviar o código</a>.</small>
							<small class="mb-2 text-success" v-if="resended">Código enviado com sucesso!</small>
						</div>
					</card-component>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import CardComponent from "@/components/Form/CardComponent";
import SuccessComponent from "@/components/Form/SuccessComponent";
import CodeInput from "@/components/Form/Inputs/CodeComponent";

export default {
	name: "AccessCodePage",
	components: {
		CardComponent,
		SuccessComponent,
		CodeInput,
	},
	async mounted() {
		if (sessionStorage.getItem("pid")) {
			this.$router.push("/form");
		}

		if (!this.$store.state.form.personal.email) {
			return this.$router.push("/");
		}

		this.loading = false;

		window.addEventListener("paste", (event) => {
			let paste = (event.clipboardData || window.clipboardData).getData("text");

			this.code = paste.replace(/\s+/g, "");
			this.customCode = this.code.split("");

			if (this.code.length == 4) {
				this.buttonDisabled = false;
			}
		});
	},
	data() {
		return {
			success: false,
			error: false,
			resended: false,
			buttonDisabled: true,
			loading: true,
			customCode: [],
		};
	},
	computed: {
		code: {
			get: function () {
				return this.$store.state.form.personal.access_code;
			},
			set: function (value) {
				this.$store.commit("setPersonal", { key: "access_code", value });
			},
		},
		email: function () {
			return this.$store.state.form.personal.email;
		},
	},
	methods: {
		setCode: function (code) {
			this.code = code;
			this.buttonDisabled = false;
		},
		changeCode: function (code) {
			if (code.length != 1 || this.customCode.length != 4) {
				this.buttonDisabled = true;
			}

			if (code.length == 4) {
				this.setCode(code);
				this.confirmCode();
			}
		},
		confirmCode: async function () {
			this.loading = true;

			const success = await this.$store.dispatch("checkToken");

			if (success) {
				this.success = true;
				this.error = false;

				setTimeout(() => {
					this.$router.push("/form");
				}, 2000);
			} else {
				this.error = true;
				this.loading = false;
			}
		},
		resendAccessToken: async function () {
			this.$emit("loading", true);
			const success = await this.$store.dispatch("resendToken");

			if (success) {
				this.resended = true;
				this.$emit("loading", false);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
p {
	font-size: 16px;
	font-family: "Montserrat", sans-serif !important;
	color: #686361;
}

p strong {
	font-size: 16px;
	font-family: "Montserrat", sans-serif !important;
	color: #686361;
}

.card-text {
	margin-bottom: 0;
}

small {
	font-size: 12px;
	font-family: "Nunito Sans", sans-serif;
	color: #686361;
	line-height: 25px;
}

small a {
	font-size: 12px;
	font-family: "Nunito Sans", sans-serif;
	text-decoration: underline;
	color: #007bff;
	line-height: 25px;
}

.button-access {
	padding: 16px 50px;
}

@media only screen and (max-width: 1024px) {
	.button-access {
		padding: 16px 20px;
	}
	.card-text {
		text-align: center;
	}
	p strong {
		font-size: 14px;
	}
	.access {
		padding: 100px 0;
	}
}
</style>
